((homepagePressQuotesCarousel, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.homePressQuoteCarousel = $('.js-home-press-quotes--quotes-slider');
    $dom.homePressLogoCarousel = $('.js-home-press-quotes--logos-slider');
  };

  const bindUIActions = () => {

    $dom.homePressQuoteCarousel.slick({
      asNavFor: $dom.homePressLogoCarousel,
      arrows: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 800
      // ,fade: true
    });


    $dom.homePressLogoCarousel.slick({
      asNavFor: $dom.homePressQuoteCarousel,
      arrows: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      focusOnSelect: true
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  homepagePressQuotesCarousel.init = init;

})(window.homepagePressQuotesCarousel = window.homepagePressQuotesCarousel || {}, jQuery);
